import { IOnInit } from "angular";
import { Record } from "../../../records/server/crud";
import {
  vsName as serverUtilityName,
  ServerUtility,
} from "../../../records/server/serverUtility";
import { StateService } from "@uirouter/angularjs";
import { $confirm } from "../../../../@custom_types/confirm";

export class ProjectDetailController implements IOnInit {
  static $inject = [
    serverUtilityName,
    "$state",
    "$confirm",
  ];

  readonly project!: Record;

  constructor(
    private readonly serverUtility: ServerUtility,
    private readonly $state: StateService,
    private readonly $confirm: $confirm,
  ) {}

  $onInit(): void {}

  deleteProject(): void {
    const { Id } = this.project;

    this.$confirm({text: "Are you sure you want to delete this configuration?"}).then(() => {
      this.serverUtility
        .sendApiRequest({
          method: "delete",
          url: `api/project/Project/${Id}`,
        })
        .then(() => {
          this.$state.go("main.project");
        });
    });
  }
}
